export default __webpack_public_path__ + "9b0d168.png";